module.exports = __webpack_public_path__ + "static/media/minus.87b3e007.jpg";